import templateUrl from './report-job-parameters.component.html';
export const ReportJobParametersComponent = {
    bindings: {
        job: "<"
    },
    templateUrl
};
